import template from './negocio.component.html';
import angular from 'angular';
import './negocio.repository';
import 'owl.carousel';

angular
    .module('Toke')
    .component('appNegocio', {
        template,
        bindings: {
            data: '<'
        },
        controller: NegocioController
    });

NegocioController.$inject = ['negocioRepository', '$timeout', '$element'];

function NegocioController(negocioRepository, $timeout, $element) {

    const vm = this;
    vm.negocio = {};


    vm.$onInit = function () {

        if (vm.data && vm.data.list) {
            vm.negocio = vm.data;

        } else {
            negocioRepository.getNegocio().then(res => {
                vm.negocio = res || {};
            });
        }
    };

    vm.$postLink = function () {
        $timeout(initOwl);
    };

    function initOwl() {

        const $owl = angular.element($element).find('.negocio__owl');

        if ($owl.data("owlCarousel") !== "undefined") {
            if (window.matchMedia('(max-width: 991px)').matches) {
                $owl.addClass("owl-carousel").owlCarousel({
                    items: 1,
                    loop: true,
                    dots: true,
                    nav: false,
                    autoplay: false,
                    autoplayTimeout: 5000,

                });
            } else {
                $owl.trigger("destroy.owl.carousel").removeClass("owl-carousel");
            }
        }
    }
}


